// extracted by mini-css-extract-plugin
export default {"attributesLineHeight":"1.8","ScreenLGMin":"(min-width: 1200px)","attributes":"Gab1700","loadingSkeleton":"G1184e3"};